import { render, staticRenderFns } from "./sociais.vue?vue&type=template&id=cfe0931a&"
import script from "./sociais.vue?vue&type=script&lang=js&"
export * from "./sociais.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports